class errorHelper {
  static fieldHasError (model, defaultClass) {
    return model ? `${defaultClass  } is-invalid` : defaultClass
  }
}

export default errorHelper
